import React from 'react';

export const MenuIconSVG = props => (
  <svg
    width="13"
    height="9"
    viewBox="0 0 13 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3105 1H0.124207V0H12.3105V1ZM12.3105 4.50072H0.124207V3.50072H12.3105V4.50072ZM0.124207 8.00141H12.3105V7.00141H0.124207V8.00141Z"
      fill="currentcolor"
    />
  </svg>
);

export const HeartIconSVG = props => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.91607 12C17.423 6.10866 12.2269 -1.90872 6.91608 2.06249C1.8346 -1.90872 -3.36155 6.10865 6.91607 12Z"
      fill="currentcolor"
      stroke="currentcolor"
    />
  </svg>
);

export const LinkIconSVG = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66797 8.66648C6.95427 9.04923 7.31954 9.36594 7.739 9.59511C8.15846 9.82428 8.62231 9.96056 9.09907 9.9947C9.57583 10.0288 10.0544 9.96006 10.5022 9.793C10.95 9.62594 11.3567 9.36453 11.6946 9.02648L13.6946 7.02648C14.3018 6.39781 14.6378 5.5558 14.6302 4.68181C14.6226 3.80782 14.2721 2.97178 13.654 2.35375C13.036 1.73573 12.2 1.38516 11.326 1.37757C10.452 1.36997 9.60998 1.70595 8.9813 2.31315L7.83464 3.45315"
      stroke="currentcolor"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33347 7.33332C9.04716 6.95057 8.68189 6.63387 8.26243 6.40469C7.84297 6.17552 7.37913 6.03924 6.90237 6.0051C6.4256 5.97095 5.94708 6.03974 5.49924 6.2068C5.0514 6.37386 4.64472 6.63527 4.3068 6.97332L2.3068 8.97332C1.69961 9.60199 1.36363 10.444 1.37122 11.318C1.37881 12.192 1.72938 13.028 2.3474 13.646C2.96543 14.2641 3.80147 14.6146 4.67546 14.6222C5.54945 14.6298 6.39146 14.2938 7.02013 13.6867L8.16013 12.5467"
      stroke="currentcolor"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditorViewIconSVG = props => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447716 16 1 16H21C21.5523 16 22 15.5523 22 15V1C22 0.447715 21.5523 0 21 0H1ZM5 8.09089L8.92071 4L9.90089 5.02272L6.96033 8.09092L9.90087 11.1591L8.92069 12.1818L5 8.09089ZM17 8.09092L13.0793 12.1818L12.0991 11.1591L15.0396 8.09091L12.0991 5.02274L13.0793 4.00001L17 8.09092Z"
      fill="currentcolor"
    />
  </svg>
);

export const SplitViewIconSVG = props => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="path-1-inside-1" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447716 16 1 16H21C21.5523 16 22 15.5523 22 15V1C22 0.447715 21.5523 0 21 0H1ZM12 2H11V14H12V2Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447716 16 1 16H21C21.5523 16 22 15.5523 22 15V1C22 0.447715 21.5523 0 21 0H1ZM12 2H11V14H12V2Z"
      fill="currentcolor"
    />
    <path
      d="M11 2V1H10V2H11ZM12 2H13V1H12V2ZM11 14H10V15H11V14ZM12 14V15H13V14H12ZM1 1V-1C-0.104569 -1 -1 -0.10457 -1 1H1ZM1 15V1H-1V15H1ZM1 15H1H-1C-1 16.1046 -0.104568 17 1 17V15ZM21 15H1V17H21V15ZM21 15V17C22.1046 17 23 16.1046 23 15H21ZM21 1V15H23V1H21ZM21 1H23C23 -0.10457 22.1046 -1 21 -1V1ZM1 1H21V-1H1V1ZM11 3H12V1H11V3ZM12 14V2H10V14H12ZM12 13H11V15H12V13ZM11 2V14H13V2H11Z"
      fill="currentcolor"
      mask="url(#path-1-inside-1)"
    />
  </svg>
);

export const PreviewViewIconSVG = props => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447716 16 1 16H21C21.5523 16 22 15.5523 22 15V1C22 0.447715 21.5523 0 21 0H1ZM9 11.4641L15 8L9 4.5359V11.4641Z"
      fill="currentcolor"
    />
  </svg>
);
